// extracted by mini-css-extract-plugin
export var cardHeader = "_gy-0";
export var reorderHandle = "_gy-3";
export var titleArea = "_gy-1";
export var titleAreaWithHandle = "_gy-2";